import { render, staticRenderFns } from "./mainSlider.vue?vue&type=template&id=d80249cc&lang=pug&"
import script from "./mainSlider.vue?vue&type=script&lang=js&"
export * from "./mainSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports